<template>
  <div class="containerDiv">
    <PCNavbar selectIndex="gw3"/>
    <MobileNavBar :currentActive="2"/>
     <!-- 头部banner图片 -->
     <!-- <img class="bannerImgcss0" src="../img3/news/yixianfengcai-title-bg.png" /> -->
     <!-- <img class="bannerImgcss0 reassembling" src="../img3/rencaijiaoliu/rencaizhaopin-bg.png" /> -->

     <!-- <img class="bannerImgcss0" src="../assets/w/img3/rencaijiaoliu/newsbg.png" /> -->
     <img class="bannerImgcss0" src="../assets/bannner/newsbg.png" />

    <!-- 二级菜单切换 -->
     <News  />
    
  </div>
</template>

<script>
import API from '@/api/index'

import News from '@/components/news/index'

import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
  
export default {
  components: {
    PCNavbar,
    MobileNavBar,
     
    News
  },
  data() {
    return {
      cengjiObj:'0',
      apitest:API.leftMenuList,
      
      
    }
  },
  mounted(){
    
  },
  methods:{
    // cengjiObjFn(obj){
    //   this.cengjiObj=obj
    // }
    
    
  }
 

}
</script>

<style lang="scss" scoped>
.roll-down-container {
  margin-top: 70px;
  width: 100%; /* 容器宽度 */
  height: 170px; /* 容器高度 */
  overflow: hidden; /* 隐藏溢出部分 */
  position: relative;
}

.roll-down-img {
  width: 100%;
  height: auto;
  transform: translateY(-100%); /* 初始位置在容器上方 */
  animation: rollDown 1.5s ease-in-out forwards;
}

@keyframes rollDown {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
.bannerImgcss0{
  width:100%;
  // margin-top:50px;
  height:auto;
  @media (max-width: 768px) {
    margin-top:0;
  }
}
.report_wrap1{
  margin-top: -1rem;
}
.containerDiv{
   min-width: 1000px;
  //  background:url('../img3/dangjian1/dangjian-bg.png');
  //  background-size:100% 100%;
  .production_card {
    width: 90vw;
    margin: 0 auto;
    // background:#ffffff;
  }
}
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }

 
}
</style>